"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGIN_TYPE = void 0;
exports.PLUGIN_TYPE = {
    PAYMENT: 'PAYMENT',
    EXTERNAL_SHOP_FEED: 'EXTERNAL_SHOP_FEED',
    FULFILLMENT: 'FULFILLMENT',
    DEPLOYMENT: 'DEPLOYMENT',
    MAILING: 'MAILING',
    SMS: 'SMS'
};
//# sourceMappingURL=pluginType.js.map